export { UaePassDetailsScreen } from './UaePassDetailsScreen';